// extracted by mini-css-extract-plugin
export default {"marquee":"Marquee_marquee__cNogu","text":"Marquee_text__yq4Tf","scroll":"Marquee_scroll__AXRMt"};